export const inHtmlTag = ({ tag, className, content }) =>
  `<${tag} class="${className}">${content}</${tag}>`;
